import { render } from "./TransfersAlert.vue?vue&type=template&id=5d269332&scoped=true"
import script from "./TransfersAlert.vue?vue&type=script&lang=js"
export * from "./TransfersAlert.vue?vue&type=script&lang=js"

import "./TransfersAlert.vue?vue&type=style&index=0&id=5d269332&scoped=true&lang=css"

import exportComponent from "/Users/renzocappelli/Lavoro/bikinilovers/newPosBKL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d269332"]])

export default __exports__